/* ============================================================================
   Toast — notificações não-bloqueantes (substitui alert()).
   API singleton: chame `toast.success('...')` de qualquer lugar.
   Renderize <ToastHost /> uma vez (já incluso no AdminLayout).
   ============================================================================ */
import { useState, useEffect } from 'react';
import { IconCheck, IconX, IconWarning } from './icons';

let listeners = [];
let items = [];
let seq = 0;

function emit() {
  listeners.forEach((fn) => fn(items));
}

export const toast = {
  show(message, type = 'info', duration = 3500) {
    const id = ++seq;
    items = [...items, { id, message, type }];
    emit();
    if (duration) setTimeout(() => toast.dismiss(id), duration);
    return id;
  },
  success(message, duration) { return this.show(message, 'success', duration); },
  error(message, duration) { return this.show(message, 'error', duration); },
  info(message, duration) { return this.show(message, 'info', duration); },
  dismiss(id) {
    items = items.filter((t) => t.id !== id);
    emit();
  },
};

const ICONS = { success: IconCheck, error: IconX, info: IconWarning };

export function ToastHost() {
  const [list, setList] = useState(items);

  useEffect(() => {
    listeners.push(setList);
    return () => { listeners = listeners.filter((fn) => fn !== setList); };
  }, []);

  return (
    <div className="mg-toast-host">
      {list.map((t) => {
        const Icon = ICONS[t.type] || IconWarning;
        return (
          <div
            key={t.id}
            className={`mg-toast mg-toast-${t.type}`}
            onClick={() => toast.dismiss(t.id)}
            role="status"
          >
            <span className="mg-toast-icon"><Icon /></span>
            <span>{t.message}</span>
          </div>
        );
      })}
    </div>
  );
}
